import { render, staticRenderFns } from "./HeartAnimation.vue?vue&type=template&id=3c6680a5"
import script from "./HeartAnimation.vue?vue&type=script&lang=js"
export * from "./HeartAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports